import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class BillingEntitiesService {
  fetchBillingEntities(params) {
    return securedAxiosInstance.get("/billing_entities", { params: toSnakeCase(params) });
  }
}

export default new BillingEntitiesService();
